<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #categoryInput
          formControlName="category" 
          [matAutocomplete]="categoryAC" 
          [placeholder]="'LABEL_CATEGORY' | translate"
          (focus)="!categoryAC.isOpen && getInitialValues('category')" 
          (blur)="checkAutocompleteObject(form, 'category')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_category_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="clearForm($event)"
          *ngIf="categoryInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!categoryInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_category_dropdown"
          [displayWith]="displayFn" 
          #categoryAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); categoryInput.blur()"
          (opened)="autocompleteScroll('category','categoryACRef','categoryACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.category && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_category_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code != 'all' ? data.code + ' - ' + data.description : data.description"
            >
            {{ data.code != 'all' ? (data.code + ' - ') : '' }} {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.category" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('category').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('category').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_CATEGORY' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>